/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import styled from 'styled-components';
import MediaQuery from 'react-responsive';
import _ from 'lodash'
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import { Button, Icon } from '@salesforce/design-system-react'
import { CustomIcon, UtilityIcon, UtilityIconButton, StandardIconButton } from '../../components/SVGIcon';
import GlobalSearch from '../../../../components/GlobalSearch';
import PopOver from '../../../shared/components/IconDropdownMenu/PopOver';
import NotificationIcon from '../../../shared/components/NotificationIcon/NotificationIcon';
import Localized from '../../../shared/components/Localized';
import LocalePickerModal from '../LocalePickerModal';
import TimezonePickerModal from '../TimezonePickerModal';
import styles from '../../styles';

//V2 components

import { MobileMenu } from '../../../../components';

const helpMenuOptions = JSON.parse(`[
    {"title":"trust","label":"Salesforce Trust","icon":"new_window","url":"https://trust.salesforce.com/{locale}/"},
    {"title":"community","label":"Trailblazer Community","icon":"new_window","url":"https://success.salesforce.com/"},
    {"title":"help","label":"Salesforce Help","icon":"new_window","url":"https://help.salesforce.com/home"},
    {"title":"userguide","label":"User Guide","icon":"page","url":"https://help.salesforce.com/s/articleView?id=sf.trust_user_guide.htm&type=5"},
    {"title":"notificationguide","label":"Notification Guide","icon":"page","url":"https://trust.salesforce.com/{locale}/trust/trust-notification-user-guide/"},
    {"title":"apidocs","label":"API Docs","icon":"page","url":"https://api.status.salesforce.com/v1/docs"},
    {"title":"privacy","label":"Privacy Statement","icon":"page","url":"https://www.salesforce.com/company/privacy/"},
    {"title":"feedback","label":"Feedback","icon":"chat","url":"https://goo.gl/forms/GQrqu3uvVXNhU8yp2"}
  ]`);
if (helpMenuOptions) {
  helpMenuOptions.forEach((options) => {
    options.icon = <UtilityIcon icon={options.icon} size='1rem' />;
  });
}

const Wrapper = styled.div`
  top: ${(p) => {
    return (p.marginTop ? p.marginTop + 'px' : 0);
  }};
  width: 100%;
  height: ${(p) => {
    return p.height + 'px' || '3rem';
  }};

  z-index: 80;
  position: fixed;

  background-color: white;
  font-size: 1rem;

  display: flex;
  justify-content: space-between;

  /* border-bottom: 1px solid #d8dde6; */
  box-shadow: 4px 0px 4px 0px rgba(0, 0, 0, 0.16);
`;

const Logo = styled.div`
  flex: 0 1 auto;

  display: flex;
  align-items: center;
  visibility: ${(props) => {
    return props.isHidden && 'hidden';
  }}
`;

const LogoImage = styled.img`
  min-width:58px;
  min-height:40px;
  max-width: 58px;
  max-height: 40px;
  margin-right: 0.5rem;
`;
const StatusDiv = styled.div`
flex: 1 1 auto;

display: flex;
align-items: center;

`;

const StatusButton = styled.button`
height: 100%;
color: #54698D;
border: none;
border-radius: 0;
`;

const DropDownArrow = styled.svg`
  display: inline;
  margin-left: 2px;
`;
const Title = styled.span`
  text-decoration: none;
  vertical-align: middle;
  font-size: 20px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #16325c;
  display: inline;
`;

const StatusTitle = styled.span`
font-size: 20px;
font-weight: 300;
font-style: normal;
font-stretch: normal;
line-height: normal;
letter-spacing: normal;
color: #54698d;
padding-right: 5px;
display: inline;
  vertical-align: middle;
`;

const SiteDropDown = styled.div`
border-radius: 4px;
box-shadow: 0 2px 3px 0 rgba(84, 105, 141, 0.5);
background-color: #ffffff;
border: solid 1px #d8dde6;
`;


const VerticalBar = styled.span`
min-height: 18px;
height: 18px;
color: #54698d;
vertical-align: middle;
font-style: normal;
font-stretch: normal;
line-height: normal;
letter-spacing: normal;
font-size: 1.10rem;

`;
const TitleAnchor = styled.a`
  :hover {
    text-decoration: none;
  };
`;

const SearchBox = styled.div`
  max-width: 25rem;
  width: 30%;

  position: relative;
  padding: 0.5rem;

  @media (max-width: 1023px) {
    display: none;
  }
`;

const UnifiedSearchBox = styled.div`
  max-width: 25rem;
  width: 85%;

  position: relative;


  @media (min-width: 320px) and (max-width: 480px) {
    max-width: 50rem;
    width: 100%;
    width:50rem;
    position: relative;
    padding-top: 0.5rem;
    padding-bottom:0.5rem;
    padding-right: 0.5rem;

  }
  @media (min-width: 1023px) {
    display: none;
  }
  @media (min-width: 768px) and (max-width: 1024px) {
    max-width: 80rem;
    width: 100%;
    width:80rem;
    padding-top: 0.5rem;
    padding-bottom:0.5rem;
    padding-right: 0.5rem;

  }
`;

const SearchBoxSVG = styled.svg`
  left: 1rem;
  width: 1rem;
  height: 1rem;
  position: absolute;
  top: 50%;
  margin-top: -0.5rem;
  line-height: 1;
  fill: #9faab5;
`;

const SerachBoxInput = styled.input`
  background-color: white;
  color: ${styles.colors.biscay};
  border: 1px solid ${styles.colors.avatar};
  border-radius: 0.25rem;
  width: 100%;
  transition: border 0.1s linear, background-color 0.1s linear;
  display: inline-block;
  padding: 0 1rem 0 2rem;
  line-height: 1.875rem;
  min-height: calc(1.875rem + (1px * 2));
`;

const UtilitiesL = styled.div`
  flex: 0 1 auto;

  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 1023px) {
    display: none;
  }

  > * {
    padding-left: 1rem;
  }
`;

const UtilitiesSM = styled.div`
  flex: 1;

  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #00396b;
  font-weight: normal;

  .logo {
    width: 3.5rem;
    height: 2.5rem;
  }

  @media (min-width: 1024px) {
    display: none;
  }
`;

const MobileSearchicon = styled(UtilityIcon)`
  margin-right: 1rem;
`;

// defining icons to be passed in for each NavMenu we have
const helpUtilityIcon = <UtilityIconButton size='1rem' icon='help' ariaLabel={'Help'} />;
const settingsUtilityIcon = <UtilityIconButton size='1rem' icon='settings' ariaLabel={'Settings'} />;
const userStandardIcon = <StandardIconButton size='1.5rem' icon='user' circle bgColor='#62B7ED' ariaLabel={'User Details'} />;
const announcementIcon = <UtilityIconButton size='1rem' icon='announcement' />;
const mobileAnnouncementIcon = <UtilityIconButton size='1.375rem' icon='announcement' />;

/**
 * Vertical Navbar used for site navigation
 */
class GlobalHeader extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      mobileMenu: false, prevLocation: props.location, searchBoxValue: props.searchBoxValue || '', dropDown: false
    };
    this.closeMobileMenu = () => {
      return this.setState({ mobileMenu: false });
    };
    this.toggleMobileMenu = () => {
      return this.setState({ mobileMenu: !this.state.mobileMenu });
    };
    this.toggleUnifiedSearchBox = () => {
      if (this.props.showUnifiedSearchBox) {
        // We're about to hide the Unified Search Box
        this.props.history.push(this.state.prevLocation.pathname);
      } else {
        this.setState({
          prevLocation: this.props.location
        });
      }

      this.props.showMobileSearch(!this.props.showUnifiedSearchBox);
    };
    this.toggleDropDown = () => {
      return this.setState({ dropDown: !this.state.dropDown });
    };
    this.hideDropDown = () => {
      return this.setState({ dropDown: false });
    };
    this.onEnter = this.onEnter.bind(this);
    this.onChange = this.onChange.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
  }

  onChange(e) {
    this.props.setSearchBoxValue(e.target.value);
  }

  onEnter(e) {
    // stay on the page if user press enter and !value
    if (e.key === 'Enter' && e.target.value) {
      this.props.history.push('/search/' + e.target.value);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({ searchBoxValue: nextProps.searchBoxValue });
  }

  async handleLogout() {
    const {logout, requests} = this.props;
    logout();
    if(requests) {
      await requests.logout.handleRequest();
      this.props.history.push('/');
    }
  }

  render() {
    const searchInputVisibility = !(this.props.location.pathname !== '/' && this.props.location.pathname !== '/current' && this.props.location.pathname !== '/current/incidents' && this.props.location.pathname !== '/current/maintenances' && this.props.location.pathname !== '/current/recentInstances');
    let generalMessagesSRText = 'No ongoing general messages. Click here to go to the general messages history page.';
    const downIcon = <UtilityIcon size='1rem' icon='down' />;

    const siteNav = <div className={this.state.dropDown ? 'container-trust border-box' : 'container-trust status-style'}><Title>Trust</Title>
      <StatusTitle> | <Localized modelName='globalHeader'
        modelAttribute='label' modelKey='status' /></StatusTitle>{downIcon}</div>;


    const {
      localeLabel, timezoneLabel, loggedIn, logout,
      requests, open, marginTop, height,
      modalOpen, modalValue, showUnifiedSearchBox, locale
    } = this.props;

    const helpMenuOptionsByLocale = helpMenuOptions.map(option => ({...option, 
      url: option.title === 'notificationguide' && locale === 'en'
        ? 'https://help.salesforce.com/s/articleView?id=sf.trust_notifications.htm&type=5' 
        : option.url.replace('{locale}', locale)}));
        
    const mobileHelpMenuOptions = helpMenuOptions.map(option => ({title: option.label, url: option.url.replace('{locale}', locale)}));

    const { mobileMenu } = this.state;

    const generalMessageList = [];

    const settingsMenuOptions = [
      {
        title: 'global',
        label: localeLabel,
        icon: <UtilityIcon size='1rem' icon='world' />,
        onClick: () => {
          return open('locale');
        }
      }, {
        title: 'timezone',
        label: timezoneLabel,
        icon: <UtilityIcon size='1rem' icon='clock' />,
        onClick: () => {
          return open('timezone');
        }
      },
    ];

    const mobileSettingsMenuOptions = [
      {
        title: `Language - ${localeLabel}`,
        onClick: () => {
          return open('locale');
        }
      }, {
        title: `Timezone - ${timezoneLabel}`,
        onClick: () => {
          return open('timezone');
        }
      },
    ];
    const siteMenuOptions = [
      {
        title: 'Home',
        label: <div><Title><Localized modelKey='Trust' modelAttribute='headerDropdown' modelName='headerDropDownMenu' /></Title> <VerticalBar>| </VerticalBar>  <StatusTitle><Localized modelKey='Home' modelAttribute='headerDropdown' modelName='headerDropDownMenu' /></StatusTitle></div>,
        icon: <UtilityIcon size='0rem' icon='world' />,
        classname: 'list-item',
        padding: 'list-anchor',
        url: 'https://trust.salesforce.com/',

      },
      {
        title: 'Security',
        label: <div><Title><Localized modelKey='Trust' modelAttribute='headerDropdown' modelName='headerDropDownMenu' /></Title>      <VerticalBar>| </VerticalBar>  <StatusTitle><Localized modelKey='Security' modelAttribute='headerDropdown' modelName='headerDropDownMenu' /></StatusTitle></div>,
        icon: <UtilityIcon size='0rem' icon='world' />,
        heigthVal: '20px',
        classname: 'list-item',
        padding: 'list-anchor',
        url: 'https://trust.salesforce.com/security',

      },
      {
        title: 'Compliance',
        label: <div><Title><Localized modelKey='Trust' modelAttribute='headerDropdown' modelName='headerDropDownMenu' /></Title> <VerticalBar>| </VerticalBar>  <StatusTitle><Localized modelKey='Compliance' modelAttribute='headerDropdown' modelName='headerDropDownMenu' /></StatusTitle></div>,
        icon: <UtilityIcon size='0rem' icon='world' />,
        classname: 'list-item',
        padding: 'list-anchor',
        url: 'https://trust.salesforce.com/compliance',
      },

    ];

    let userMenuOptions = {};
    if (loggedIn) {
      userMenuOptions = [
        {
          title: 'my_subscription',
          label: <Localized modelKey='mySubscription' modelAttribute='userOptions' modelName='iconDropdownMenu' />,
          icon: <CustomIcon size='1.5rem' icon='custom53' bgColor='#EB706A' round />,
          url: '/subscriptions',
        }, {
          title: 'log_out',
          label: <Localized modelKey='logOut' modelAttribute='userOptions' modelName='iconDropdownMenu' />,
          icon: <UtilityIcon size='1rem' icon='logout' />,
          bgColor: '#F4F6F9',
          onClick: () => {
            logout();
            return requests ? requests.logout.handleRequest()
              .then(() => {
                return this.props.history.push('/');
              }) : null;
          }
        },
      ];
    } else {
      userMenuOptions = [
        {
          title: 'log_out',
          label: <Localized modelKey='logIn' modelAttribute='userOptions'
            modelName='iconDropdownMenu' />,
          icon: <UtilityIcon size='1rem' icon='logout' />,
          url: '/login',
          bgColor: '#F4F6F9',
        }
      ];
    }

    if (requests.generalMessages.value) {
      const ongoingGeneralMessages = requests.generalMessages.value.filter((gm) => {
        return gm.endDate === null || moment(gm.endDate).isAfter(moment());
      });
      const numberOfOngoingGMs = ongoingGeneralMessages.length;
      if (numberOfOngoingGMs) {
        generalMessagesSRText = `${numberOfOngoingGMs} ongoing general messages. Click here to go to the general messages history page.`;
      }
      generalMessageList.push(...ongoingGeneralMessages);
    }

    return (
      <Wrapper height={height} marginTop={marginTop} className="slds-p-horizontal_medium">
        {modalOpen && modalValue === 'locale' && <LocalePickerModal
          onTimezoneChange={this.onTimzesonChange} onClose={this.props.close} />}
        {modalOpen && modalValue === 'timezone' && <TimezonePickerModal
          onClose={this.props.close} />}
        <MediaQuery maxWidth={1023}>
          <MobileMenu
              showMenu={mobileMenu}
              helpMenuOptions={mobileHelpMenuOptions}
              settingsMenuOptions={mobileSettingsMenuOptions}
              onClose={this.closeMobileMenu}
              onLogout={this.handleLogout}
          />
        </MediaQuery>
        {<UtilitiesL>
            <Logo isHidden={mobileMenu}>
            <a href="https://trust.salesforce.com">  <LogoImage alt="Salesforce Logo" src='/assets/images/SF_LOGO.svg' /></a>
              {!showUnifiedSearchBox && <TitleAnchor>
                <div>
                  <PopOver
                    elem={siteNav} toggleParent={this.toggleDropDown} hideParent={this.hideDropDown}
                    dropdownProps={Object.assign({}, {
                      heading: '', menuOptions: siteMenuOptions, offsetRight: '-7.3rem', skipSeparator: true, style: { width: '12rem' }
                    })} />
                </div>
              </TitleAnchor>}
            </Logo>
          </UtilitiesL>
        }
        {showUnifiedSearchBox && <GlobalSearch />}
        <MediaQuery minWidth={1023}>
        {!showUnifiedSearchBox && !searchInputVisibility && <GlobalSearch />}
        </MediaQuery>
        <UtilitiesL>
          {(helpMenuOptions) && <PopOver
            data-testid="helper-links"
            elem={helpUtilityIcon}
            dropdownProps={Object.assign({}, { heading: 'help', menuOptions: helpMenuOptionsByLocale })} />}
          <PopOver
            data-testid="settings"
            elem={settingsUtilityIcon}
            dropdownProps={Object.assign({}, { heading: 'settings', menuOptions: settingsMenuOptions })} />
          <NotificationIcon
            iconElement={announcementIcon}
            showRedDot={generalMessageList.length !== 0}
            targetUrl={'/generalmessages/'}
            linkTitle={generalMessagesSRText}
          />
          <PopOver
            data-testid="user-profile-button"
            elem={userStandardIcon}
            dropdownProps={Object.assign({}, { heading: 'user', menuOptions: userMenuOptions })} />
        </UtilitiesL>
        {!mobileMenu &&
          <UtilitiesSM isHomePage={searchInputVisibility}>
            {!showUnifiedSearchBox &&
              <div className="slds-grid slds-grid_vertical-align-center slds-col">
                <Button title="Open Mobile Menu" assistiveText={{ icon: 'Open Mobile Menu' }} iconCategory="utility" iconName="rows" iconSize="large" variant="icon" onClick={this.toggleMobileMenu} />
                <div className="slds-text-heading_medium slds-m-left--medium mobile-header">
                  <img src="/assets/images/SF_LOGO.svg" alt="Salesforce" className="slds-m-right_x-small logo" />
                  <span className="slds-p-right_x-small slds-border_right">Trust</span>
                  <span className="slds-p-left_x-small">Status</span>
                </div>
              </div>
            }
            {!showUnifiedSearchBox && !searchInputVisibility && <Button
                assistiveText={{ icon: 'general message' }}
                iconCategory="utility"
                iconName="search"
                iconSize="large"
                variant="icon"
                onClick={this.toggleUnifiedSearchBox} />}
            {!showUnifiedSearchBox && <NotificationIcon
              iconElement={<Icon
                assistiveText={{ label: 'general message' }}
                category="utility"
                name="announcement"
                size="small"
              />}
              showRedDot={generalMessageList.length !== 0}
              linkTitle={generalMessagesSRText}
              targetUrl={'/generalmessages/'} />}
            {showUnifiedSearchBox && <UtilityIcon size='1.5rem'
              icon='close' onClick={this.toggleUnifiedSearchBox} />}
          </UtilitiesSM>
        }
      </Wrapper>
    );
  }
}

export default withRouter(GlobalHeader);
